import { AuthBranding as Branding } from "components/common/branding";
import { PushDown } from "components/common/container";
import Navigation from "components/layout/Navigation";
import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import PublicViewRoute from "routing/PublicViewRoute";
import { ROUTES } from "utils/constants/routes-constants";
import lazy from "utils/lazyWithRetry";
import styled from "styled-components";
import { Overlay } from "components/common/container/Overlay";
import { useWindowSize } from "hooks/useWindowSize";
import { useOffcanvas } from "hooks/useOffcanvas";
import AuthGuard from "authentication/AuthGuard";
import UserLogin from "user/UserLogin";
import SignUp from "user/SignUp";
import { Logout } from "pages/Logout";
import { ResetPasswordEmailVerify } from "user/ResetPasswordEmailVerify";
import { ResetPassword } from "user/ResetPassword";
const VerifyEmailInput = lazy(() => import("user/UserSignUpVerifyEmail"));

const Container = styled.div`
  overflow: hidden;
`;

// routes
const PortalRoutes = lazy(() => import("routing/PortalRoutes"));
const WorkingCapitalCalculator = lazy(() =>
  import("pages/WorkingCapitalCalculator")
);

const Router = () => {
  const { width } = useWindowSize();
  const { offcanvas, handleOpen } = useOffcanvas(width);

  return (
    <Suspense fallback={<Branding />}>
      <Routes>
        <Route path={ROUTES.SIGN_UP} element={<SignUp />} />
        <Route path={ROUTES.LOGOUT} element={<Logout />} />
        <Route path={ROUTES.VERIFY_EMAIL} element={<VerifyEmailInput />} />
        <Route
          path={ROUTES.RESET_PASSWORD_EMAIL_VERIFY}
          element={<ResetPasswordEmailVerify />}
        />
        <Route path={ROUTES.RESET_PASSWORD} element={<ResetPassword />} />
        <Route
          path={ROUTES.WORKING_CAPITAL}
          element={
            <Container>
              <Navigation
                width={width}
                active={offcanvas}
                handleOpen={handleOpen}
                isPublic
              />
              <Overlay active={offcanvas} />
              <PushDown active={offcanvas}>
                <PublicViewRoute
                  path={ROUTES.WORKING_CAPITAL}
                  redirectRoute={ROUTES.WORKING_CAPITAL_AV}
                  component={WorkingCapitalCalculator}
                  exact
                />
              </PushDown>
            </Container>
          }
          exact
        />
        <Route
          path={ROUTES.ALL}
          element={
            <AuthGuard>
              <UserLogin>
                <PortalRoutes />
              </UserLogin>
            </AuthGuard>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default Router;
